import { c as _c } from "react/compiler-runtime";
import { Checkbox, Checkmark2Icon, FontWeights, MenuItem } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { MarkupStatusIcon } from "@pages/project-details/project-markups/status/markup-status-icon";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Renders items inside the markup status dropdown */
export function MarkupStatusDropdownItem(t0) {
  const $ = _c(28);
  const {
    markupOption,
    activeStatuses,
    onStatusChange,
    shouldShowCheckbox: t1
  } = t0;
  const shouldShowCheckbox = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== activeStatuses || $[1] !== markupOption.value) {
    t2 = activeStatuses?.includes(markupOption.value);
    $[0] = activeStatuses;
    $[1] = markupOption.value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isStatusActive = t2;
  let t3;
  if ($[3] !== markupOption.value || $[4] !== onStatusChange) {
    t3 = () => onStatusChange(markupOption.value);
    $[3] = markupOption.value;
    $[4] = onStatusChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isStatusActive || $[7] !== shouldShowCheckbox) {
    t4 = shouldShowCheckbox && <Checkbox checked={isStatusActive} />;
    $[6] = isStatusActive;
    $[7] = shouldShowCheckbox;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isStatusActive ? "primary.main" : "inherit";
  let t6;
  if ($[9] !== t5) {
    t6 = {
      alignItems: "center",
      gap: "20px",
      flexDirection: "row",
      fontSize: "14px",
      fontWeight: FontWeights.Regular,
      color: t5
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== markupOption.value) {
    t7 = <MarkupStatusIcon status={markupOption.value} shouldHaveBorder={true} />;
    $[11] = markupOption.value;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isStatusActive || $[14] !== shouldShowCheckbox) {
    t8 = !shouldShowCheckbox && isStatusActive && <Checkmark2Icon style={{
      fontSize: "13px",
      color: PALETTE_VARS.primary.main,
      fontWeight: FontWeights.Bold,
      width: "18px",
      height: "18px"
    }} />;
    $[13] = isStatusActive;
    $[14] = shouldShowCheckbox;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== markupOption.label || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <Stack sx={t6}>{t7}{markupOption.label}{t8}</Stack>;
    $[16] = markupOption.label;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isStatusActive || $[22] !== markupOption.key || $[23] !== markupOption.value || $[24] !== t3 || $[25] !== t4 || $[26] !== t9) {
    t10 = <MenuItem disableRipple={true} disableTouchRipple={true} key={markupOption.key} value={markupOption.value} selected={isStatusActive} onClick={t3}>{t4}{t9}</MenuItem>;
    $[21] = isStatusActive;
    $[22] = markupOption.key;
    $[23] = markupOption.value;
    $[24] = t3;
    $[25] = t4;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}